import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle, Loader2, Crown } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let mounted = true;
    const poll = async (n = 0) => {
      if (n >= 8) { if (mounted) setStatus("timeout"); return; }
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (!mounted) return;
        setAttempts(n + 1);
        if (r.data.payment_status === "paid") setStatus("paid");
        else if (r.data.status === "expired") setStatus("expired");
        else setTimeout(() => poll(n + 1), 2000);
      } catch { if (mounted) setStatus("error"); }
    };
    poll();
    return () => { mounted = false; };
  }, [sessionId]);

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center p-6" data-testid="payment-result-page">
      <div className="mec-card p-10 max-w-md w-full text-center">
        {status === "polling" && (
          <>
            <Loader2 className="w-12 h-12 text-[#004EEB] animate-spin mx-auto mb-4" />
            <h2 className="font-display text-2xl font-bold text-slate-900 mb-2">Vérification du paiement...</h2>
            <p className="text-slate-600 text-sm">Tentative {attempts}/8</p>
          </>
        )}
        {status === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4">
              <CheckCircle2 className="w-8 h-8 text-emerald-600" />
            </div>
            <h2 className="font-display text-2xl font-bold text-slate-900 mb-2">Paiement confirmé !</h2>
            <p className="text-slate-600 text-sm mb-6">Votre compte est désormais Premium <Crown className="w-4 h-4 inline text-amber-500" />. Profitez de toutes les fonctionnalités.</p>
            <Link to="/dashboard"><Button className="bg-[#004EEB] hover:bg-[#003BCC] text-white">Aller au tableau de bord</Button></Link>
          </>
        )}
        {(status === "error" || status === "expired" || status === "timeout") && (
          <>
            <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-8 h-8 text-red-600" />
            </div>
            <h2 className="font-display text-2xl font-bold text-slate-900 mb-2">Paiement non finalisé</h2>
            <p className="text-slate-600 text-sm mb-6">Le paiement n'a pas pu être confirmé. Vous pouvez réessayer.</p>
            <Link to="/pricing"><Button variant="outline">Retour aux tarifs</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
